import i18n from "../i18n";
const t = (k: string, fb?: string) => (i18n.t ? i18n.t(k, fb || k) : fb || k);
export const permissionOptions = [
	{ id: '2', name: 'Xem', description: t("Xem và sử dụng", "Xem và sử dụng") },
	{ id: '3', name: t("Chỉnh sửa", "Chỉnh sửa"), description: t("Điều chỉnh và chia sẻ lại", "Điều chỉnh và chia sẻ lại") },
	{ id: '1', name: t("Chuyển quyền tác giả", "Chuyển quyền tác giả"), description: '' },
	{ id: '4', name: t("Xóa quyền truy cập", "Xóa quyền truy cập"), description: '' },
];

export const generalAccessOptions = [
	{ id: '1', name: t("Hạn chế", "Hạn chế") },
	{ id: '2', name: t("Công khai", "Công khai") },
	{ id: '3', name: t("Nhóm trường", "Nhóm trường") },
	{ id: '4', name: t("Nhóm đại học", "Nhóm đại học") },
];

export const sharePermissionType = {
	QUESTION_BANK: "question_bank",
	UNIT_RESOURCE: "unit_resource"
}


export const transformUniversityTreeData = (data: any) =>
	data.map((item: any) => ({
		title: item.name,
		value: item.universityId,
		key: item.universityId,
		children: item.children ? transformUniversityTreeData(item.children) : [],
	}));
